<template>
  <div id="kol-entity-post-list">
    <div class="row m-t-20" v-if="post">
      <div
        id="statement"
        class="col-12 scroller"
        style="max-height: 20rem"
        v-if="post.length > 0"
      >
        <div class="row">
          <div
            class="col-md-4 m-b-10"
            v-for="(item, index) in post"
            :key="index"
          >
            <div
              class="card card-default border p-l-15 p-r-15 p-t-15 p-b-15 h-100"
              style="border-radius: 10px"
            >
              <div
                class="font-weight-bolder clickable hoverable text-justify"
                @click="showDetailModal(item.id_stream.$oid)"
              >
                {{ item.title }}
              </div>

              <span class="fs-12" style="margin-top: 2px !important">
                {{ dateindo(item.date.$date) }} on {{ item.account }}
              </span>
              <div class="d-flex mt-3">
                <img
                  :src="item.thumbnail"
                  class="border"
                  style="
                    border-radius: 8px;
                    width: 130px;
                    height: 90px;
                    object-fit: cover;
                  "
                />
                <div class="ml-2 text-justify">
                  {{
                    item.content
                      ? writeContent(item.content)
                      : "Konten Tidak Tersedia!"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-md-12 col-sm-12 col-lg-12">
        <div
          class="alert alert-danger mt-3"
          id="errorApiEl"
          role="alert"
          align="center"
        >
          <strong>Mohon maaf, data tidak tersedia! </strong> <br />
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
    </div>
    <modal-detail-post-component
      v-if="isShowModalDetail"
      :id_stream="id_stream"
      :key="detail_key"
      @close="closeModalDetail"
    />
    <modal-dynamic-component
      v-if="show_modal_dynamic"
      :key="modal_dynamic_key"
      modal_id="modal-edit-post"
      :modal="modal_dynamic"
      :data="statement_data"
      modal_size="modal-lg"
    />
  </div>
</template>
  
  <script>
import $ from "jquery";
import gp from "@/plugins/generalPlugins.js";
import modal_detail_post from "@/views/components/mention/modal_detail_post.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";

export default {
  name: "kol_entity_post_list",
  components: {
    "modal-detail-post-component": modal_detail_post,
    "modal-dynamic-component": modal_dynamic,
  },
  props: {
    post: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      search: "",
      id_stream: null,
      detail_key: 300,
      modal_dynamic_key: 100,
      show_modal_dynamic: false,
      statement_data: null,
      isShowModalDetail: false,
    };
  },
  methods: {
    showDetailModal: function (id) {
      this.id_stream = id;
      this.detail_key++;
      this.isShowModalDetail = true;
    },
    closeModalDetail: function () {
      this.isShowModalDetail = false;
    },
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    writeContent: function (text) {
      if (text.length > 150) {
        var newText = text.substring(0, 150);
        return newText + "...";
      } else {
        return text;
      }
    },
    imageUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.isShowModalDetail = false;
      }
    });
  },
  mounted() {
    let self = this;
    $("#quote-post").on("#modal hidden.bs.modal", function () {
      self.isShowModalDetail = false;
    });
  },
};
</script>